<template>
  <div class="svgBox" :style="{ color: color }">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 523 236" class="design-iconfont">
      <path opacity=".1" fill="currentColor" d="M0 137.529H18.5461V202.9996H0z"/>
      <path opacity=".2" fill="currentColor" d="M22.2551 111.588H40.801199999999994V202.9998H22.2551z"/>
      <path opacity=".1" fill="currentColor" d="M96.4399 131.353H114.98599999999999V203.0001H96.4399z"/>
      <path opacity=".2" fill="currentColor" d="M118.695 56H137.2411V203H118.695z"/>
      <path opacity=".1" fill="currentColor" d="M192.88 95.5293H211.4261V203.0003H192.88z"/>
      <path opacity=".2" fill="currentColor" d="M215.135 125.177H233.6811V203.0005H215.135z"/>
      <path opacity=".1" fill="currentColor" d="M289.319 115.294H307.86510000000004V202.9999H289.319z"/>
      <path opacity=".2" fill="currentColor" d="M311.574 80.7061H330.12010000000004V203.0001H311.574z"/>
      <path opacity=".1" fill="currentColor" d="M385.759 137.529H404.30510000000004V202.9996H385.759z"/>
      <path opacity=".2" fill="currentColor" d="M408.014 101.706H426.56010000000003V203H408.014z"/>
      <path opacity=".1" fill="currentColor" d="M482.199 95.5293H500.74510000000004V203.0003H482.199z"/>
      <path opacity=".2" fill="currentColor" d="M504.454 56H523.0001V203H504.454z"/>
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 3.5L523 3.5"/>
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 43.5L523 43.5"/>
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 83.5L523 83.5"/>
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 123.5L523 123.5"/>
      <path stroke="currentColor" stroke-opacity=".1" stroke-dasharray="4 4" d="M0 163.5L523 163.5"/>
      <path d="M0 204H523V205H0V204Z" fill="currentColor" fill-opacity=".1"/>
      <path fill="#86909C" d="M16.2183 208H16.781747V210.34211H16.2183z"/>
      <path fill="#86909C" d="M114.218 208H114.781447V210.34211H114.218z"/>
      <path fill="#86909C" d="M212.218 208H212.781447V210.34211H212.218z"/>
      <path fill="#86909C" d="M310.218 208H310.781447V210.34211H310.218z"/>
      <path fill="#86909C" d="M408.218 208H408.781447V210.34211H408.218z"/>
      <path fill="#86909C" d="M506.218 208H506.781447V210.34211H506.218z"/>
    </svg>
    <div class="no-data-text">当前无数据</div>
  </div>

</template>
<script>
export default {
  name: "noDataSvg",
  props: {
    color: {
      type: String,
      default: '#787A80',
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.svgBox {
  width: 100%;
  height: 94%;
  position: relative;

  svg {
    width: 100%;
    height: 100%;
  }

  .no-data-text {
    position: absolute;
    top: 65%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    opacity: 0.7;
  }
}
</style>
